import React from 'react';
import { connect } from 'react-redux';
import { Tooltip, Checkbox } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';

const styles = theme => ({
    segmentSelectCheckbox: {
        padding: 4,
        position: 'absolute',
        right: 0,
        bottom: 0,
        '& svg': {
            width: '0.8em',
            height: '0.8em'
        }
    }
});

const SegmentCheckbox = (props) => {
    const { classes, segmentChecked, updateLyricsSegment, index } = props;
    const checked = Boolean(segmentChecked);

    const onCheckboxChange = (event) => {
        updateLyricsSegment(index, {
            checked: event.target.checked
        });
    };

    return (
        <Tooltip 
            title={checked ? 'Deselect' : 'Select'} 
            placement='right'
        >
            <Checkbox
                className={classes.segmentSelectCheckbox}
                color='default'
                inputProps={{ 'aria-label': 'select lyrics segment' }}
                size='small'
                checked={checked}
                onChange={onCheckboxChange}
                unselected-checkbox={(!Boolean(segmentChecked)).toString()}
                sx={{ width: '26px', height: '26px' }}
            />
        </Tooltip>
    );
}

const mapStateToProps = (state) => {
    return {};
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsSegment = (index, properties) => dispatch(createActions.updateLyricsSegment(index, properties));

    return {
        updateLyricsSegment
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SegmentCheckbox, styles));